// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"6f874e2d","132":"6f874e2d","544":"77d9c842","740":"6f874e2d","888":"6f874e2d"}[chunkId] + ".chunk.css";
};